<template>
  <div class="combination_box">
    <div class="poll_box default_type">
      <h4>섭취 기간을 선택해주세요.</h4>
      <div class="form_group-element">
        <span class="form_element-radio">
          <input
            id="day_chk01"
            v-model="days"
            type="radio"
            name="day_chk"
            value="30"
          >
          <label
            for="day_chk01"
            class="focus"
          >30일</label>
        </span>
        <!-- <span class="form_element-radio">
          <input
            id="day_chk02"
            v-model="days"
            type="radio"
            name="day_chk"
            value="45"
          >
          <label
            for="day_chk02"
            class="focus"
          >45일</label>
        </span> -->
        <!-- <span class="form_element-radio">
          <input
            id="day_chk03"
            v-model="days"
            type="radio"
            name="day_chk"
            value="50"
          >
          <label
            for="day_chk03"
            class="focus"
          >50일</label>
        </span> -->
        <!-- <span class="form_element-radio">
          <input
            id="day_chk03"
            v-model="days"
            type="radio"
            name="day_chk"
            value="60"
            disabled
          >
          <label
            for="day_chk03"
            class="focus"
          >60일</label>
        </span> -->
      </div>
    </div>
    <div class="poll_box default_type">
      <h4>하루 섭취 횟수를 선택해주세요.</h4>
      <div class="form_group-element">
        <span class="form_element-radio">
          <input
            id="oneday_chk01"
            v-model="pockets"
            type="radio"
            name="oneday_chk"
            value="1"
          >
          <label
            for="oneday_chk01"
            class="focus"
          >1회</label>
        </span>
        <span class="form_element-radio">
          <input
            id="oneday_chk02"
            v-model="pockets"
            type="radio"
            name="oneday_chk"
            value="2"
          >
          <label
            for="oneday_chk02"
            class="focus"
          >2회</label>
        </span>
        <!-- <span class="form_element-radio">
          <input
            id="oneday_chk03"
            v-model="pockets"
            type="radio"
            name="oneday_chk"
            value="3"
          >
          <label
            for="oneday_chk03"
            class="focus"
          >3포</label>
        </span> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompositionOptionsSection',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      days: this.value.days || 30,
      pockets: this.value.pockets,
    };
  },
  watch: {
    days() {
      this.onChange();
    },
    pockets() {
      this.onChange();
    },
  },
  methods: {
    onChange() {
      this.$emit('input', {
        days: this.days,
        pockets: this.pockets,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/main/step2/CompositionOptionsSection.vue